import type { Reducer } from 'redux';
import { ApiRequestStatus } from '@makemydeal/dr-shared-types';
import { SAVE_TRADE_RECON_COST, UPDATE_TRADE_RECON_ITEMS } from '../actionTypes/tradeReconCostActionTypes';
import type { TradeReconCostState } from '../types/tradeReconCostTypes';
import { OFFER_SAVE_SUCCESS } from '../actionTypes/offerActionTypes';

const INITIAL_STATE: TradeReconCostState = {
    tradeReconData: {},
    isUpdateTradeReconStatus: ApiRequestStatus.Idle
};

export type TradeReconCostScopedReducer = Reducer<TradeReconCostState>;

export const reducer: TradeReconCostScopedReducer = (state = INITIAL_STATE, action: any) => {
    switch (action.type) {
        case UPDATE_TRADE_RECON_ITEMS:
            return {
                ...state,
                tradeReconData: action.payload
            };
        case SAVE_TRADE_RECON_COST:
            return {
                ...state,
                isUpdateTradeReconStatus: ApiRequestStatus.Loading
            };
        case OFFER_SAVE_SUCCESS:
            return {
                ...state,
                isUpdateTradeReconStatus: ApiRequestStatus.Success
            };
        default:
            return state;
    }
};
